import styled from "styled-components";

export const EmptyTableWrapper =  styled.div`
width:100%;
height:711px;
display:flex;
flex-direction:column;
justify-content: center;
align-items: center;
background:#f3f4f7;
border: 1px dotted #DDE2E9;
`
export const EmptyTableLAbel =  styled.div`
width:184px;
font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 0.833rem;
leading-trim: Cap height;
line-height: 20px;
letter-spacing: 0px;
text-align: center;
vertical-align: middle;
`
export const EmptyLabelButton = styled.span`
border:none;
color:#0C53BB;
`
export const SuccessContainer = styled.div`
display:flex;
gap:10px;
font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 0.833rem;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
color:#48566B;
align-items:center;
`
export const SuccessContainerWrapper = styled.div`
display :flex;
align-items:center;
`